'use strict';

import $, { fn } from 'jquery';
import Swiper from 'swiper';
import 'bootstrap';
import AOS from 'aos';

window.$ = $;
window.jQuery = $;

window.Swiper = Swiper;
window.AOS = AOS;


window.marquee = {
  init: function () {
    var element = $('.marquee');
    var _this = this;
    element.each(function (i) {
      if (_this.isElementOverflowing(element[i])) {
        _this.wrapContentsInMarquee(element[i]);
      }
    });

  },
  isElementOverflowing: function (element) {
    var overflowX = element.offsetWidth < element.scrollWidth;

    return (overflowX);
  },
  wrapContentsInMarquee: function (element) {
    var marquee = document.createElement('div'),
        clone = document.createElement('div'),
        contents = element.innerText;
        
    marquee.className = 'origin';
    marquee.innerText = contents;
    clone.className = 'clone';
    clone.innerText = contents;
    element.innerHTML = '';
    element.appendChild(marquee);
    element.appendChild(clone);
    element.className = 'marquee ani';
    var duration = (marquee.offsetWidth)/30+ 's';
    marquee.style.animationDuration = duration;
    clone.style.animationDuration = duration;
  }

}

$(function () {
  // marquee.init();
  $('.button-hamburger').on('click', function () {
    $('body').addClass('is_side_menu_open');
    $('.side_menu').on('click', function () {
      $('body').removeClass('is_side_menu_open');
    });
  });

  // $('.dropdown-toggle').dropdown();

  AOS.init({
    duration: 1200
  });

  $('.dropdown').each(function () {
    var that = $(this);
    that.find('.dropdown-toggle .label').text(that.find('.active').text());
    that.find('.dropdown-menu a').on('click', function () {
      that.find('.active').removeClass('active');
      that.find('.dropdown-toggle .label').text($(this).text());
      $(this).addClass('active');
    });
  });

  $(window).on('scroll.bodyScroll', fnBodyScroll);

  function fnBodyScroll() {
    var that = $(this);
    if (that.scrollTop() >= 52) {
      $('body').addClass('fixed');
    } else {
      $('body').removeClass('fixed');
    }
  }

  $('.notice').on('click','.notice-question',function(e){
		e.preventDefault();
    $(this).next(".notice-answer").slideToggle(100).parents('li').toggleClass('on');
  });
  
  var $window = $(window),
        $body = $("body"),
        $modal = $(".modal"),
        scrollDistance = 0;

  $modal.on("show.bs.modal", function() {
      // Get the scroll distance at the time the modal was opened
      scrollDistance = $window.scrollTop();

      // Pull the top of the body up by that amount
      $body.css("top", scrollDistance * -1);
      $(window).off('scroll.bodyScroll');
  });

  $modal.on("hidden.bs.modal", function() {
    // Remove the negative top value on the body
    $body.css("top", "");

    // Set the window's scroll position back to what it was before the modal was opened
    $window.scrollTop(scrollDistance);
    $(window).on('scroll.bodyScroll' , fnBodyScroll);
  });
});